import React from 'react';
import { IBadgeListCell } from './interfaces';
import { ValueCell } from '../ValueCell';
import { BadgeList } from '@components/badges';

export const BadgeListCell: React.FC<IBadgeListCell> = ({
  items,
  maxItems = 2,
}): JSX.Element => {
  if (!items.length) {
    return <ValueCell value={undefined} />;
  }

  return (
    <BadgeList
      items={items}
      maxItems={maxItems}
      sx={{
        height: '100%',
      }}
    />
  );
};
